define('modules/editor/models/property_groups/page_popup',['require','exports','module','./base'],function(require, exports, module) {
  "use strict";
  var BasePropertyGroup = require('./base');

  module.exports = BasePropertyGroup.extend({
    name: 'page:popup',
    properties: [
      // Main
      'title',

      // Geometry
      'width', 'height', 'windowPosition', 'windowRadius',

      // Overlay
      'closeOnClickOutside', 'useOverlay', 'overlayOpacity', 'overlayColor', 'shadowColor',

      // Fonts and colors:
      'fontFamily', 'backgroundColor', 'fontColor', 'linkColor'
    ],
    applyStyles: function($el) {},

    validators: {
      // width: function(attrs) {
      //   var value = parseInt(attrs.width, 10);
      //   return this.isInteger(attrs.width) && this.isInteger(value) && (value >= 100);
      // },
      // height: function(attrs) {
      //   var value = parseInt(attrs.height, 10);
      //   return this.isInteger(attrs.height) && this.isInteger(value) && (value >= 100);
      // },
      windowRadius: function(attrs){
        var value = attrs.windowRadius,
          number = parseInt(value);
        return this.isInteger(value) && number >= 0 && number <= 20;
      }
    }
  });
});

